// ADMIN JS
jQuery(function ($) {
  $(document).ready(function () {
    setTimeout(function () {
      var the_count = 1;
      $('th.acf-th[data-key="field_5afa71902369a"]').each(function () {
        $(this).append(
          '<br /><i class="bo_selector">Confirmed to Attended</i>'
        );
      });
      $('th.acf-th[data-key="field_5afa71902369a"] i').click(function () {
        $("td.acf-field-5afa71902369a").each(function () {
          var whatIsTheStatus = "";
          whatIsTheStatus = $(this).find("input:checked").val();
          if (whatIsTheStatus == "confirmed") {
            $(this).find('input[value="attended"]').trigger("click");
          }
        });
      });
      $(".bo_selector").css({
        padding: "3px",
        "border-radius": "4px",
        "font-size": "12px",
        "background-color": "#3472a5",
        color: "white",
        cursor: "pointer",
      });
      // CERTIFICATE & INVOICES
      $('th.acf-th[data-key="field_5b838c21ab18a"]').each(function () {
        $(this).append(
          '<br /><i id="assign_inv" class="inv_selector">Bulk assign invoices</i>'
        );
      });
      $('th.acf-th[data-key="field_5ba45c26954f5"]').each(function () {
        $(this).append(
          '<br /><i id="assign_cert" class="cert_selector">Bulk assign certificates</i>'
        );
      });
      $(".inv_selector, .cert_selector").css({
        padding: "3px",
        "border-radius": "4px",
        "font-size": "12px",
        "background-color": "#3472a5",
        color: "white",
        cursor: "pointer",
      });
      $("#assign_cert").click(function () {
        $(this).text("Working...");
        // GET POST ID (via query string)
        function get_event_id() {
          var vars = [],
            hash;
          var hashes = window.location.href
            .slice(window.location.href.indexOf("?") + 1)
            .split("&");
          for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split("=");
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
          }
          return vars;
        }
        var the_event_id = get_event_id()["post"];
        // AJAX CALL
        var data = {
          action: "assign_certs",
          send_the_event_id: the_event_id,
        };
        jQuery.post(ajaxurl, data, function (response) {
          location.reload();
          //alert(response);
          if (!response.length) {
          }
        });
      });
      $("#assign_inv").click(function () {
        $(this).text("Working...");
        // GET POST ID (via query string)
        function get_event_id() {
          var vars = [],
            hash;
          var hashes = window.location.href
            .slice(window.location.href.indexOf("?") + 1)
            .split("&");
          for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split("=");
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
          }
          return vars;
        }
        var the_event_id = get_event_id()["post"];
        // AJAX CALL
        var data = {
          action: "assign_invoice",
          send_the_event_id: the_event_id,
        };
        jQuery.post(ajaxurl, data, function (response) {
          location.reload();
          //alert(response);
          if (!response.length) {
          }
        });
      });
    }, 500);
  });
});
